<button
  type="button"
  class="lock-toggle-btn"
  [class.lock-toggle-btn--unlocked]="unlocked"
  [class.lock-toggle-btn--locked]="!unlocked"
  [attr.aria-label]="unlocked ? 'Campo desbloqueado' : 'Campo bloqueado'"
  [attr.title]="unlocked ? 'Campo desbloqueado. Pulsa para bloquear.' : 'Campo bloqueado. Pulsa para desbloquear.'"
  (click)="pressed.emit(); $event.preventDefault(); $event.stopPropagation()"
>
  <img
    [src]="unlocked ? 'svg/unlock.svg' : 'svg/lock.svg'"
    [alt]="unlocked ? 'Desbloqueado' : 'Bloqueado'"
  />
</button>
